export default __webpack_public_path__ + "static/media/Plissee 22 mm reversibel.1f44fbca.jpg";